import { Button } from "@mui/material";
import React from "react";
import EastIcon from "@mui/icons-material/East";
import { APP_COLORS } from "../../../../utils/constants";

export default function SubmitBtn({ onSubmit, loading }) {
  const [isHovering, setIsHovering] = React.useState(false);

  return (
    <Button
      onClick={onSubmit}
      variant={isHovering ? "contained" : "outlined"}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      color="white"
      endIcon={<EastIcon sx={{ ml: ".7rem" }} />}
      sx={{
        backgroundColor: isHovering && APP_COLORS.BACKGROUND,
        color: isHovering && APP_COLORS.FONT,
        p: 1.5,
        mt: 3.3,
        px: "1.5rem",
        opacity: loading && 0.5,
        borderRadius: "3rem",
        border: "1px solid white",
        "&:hover": {
          border: "1px solid transparent",
        },
        transition: "all .3s ease-out",
      }}
    >
      {loading
        ? "Sending..."
        : isHovering
        ? "Schedule a meeting  "
        : "Send Message  "}
    </Button>
  );
}
